// extracted by mini-css-extract-plugin
export var circle = "_dw-1";
export var exitConfirmationModal = "_dw-5";
export var iframe = "_dw-0";
export var offline = "_dw-3";
export var online = "_dw-2";
export var workstationSelectError = "_dw-4";